import React, { useEffect, useState } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form } from "react-bootstrap";
import "./SessionTokenBasedLocation.css";
import usePost from "../../../customhooks/UsePost";
import { useLoaderData } from "react-router-dom";

const NewLocationInput = ({
  value,
  placeholder,
  size,
  autoSuggestCssClassName,
  page,
  setValue,
  locationObj,
}) => {
  const loaderDetails = useLoaderData();
  const {
    post: getLocationSuggestions,
    data: suggestionsdata,
    isLoading: getLocationSuggestionsLoading,
  } = usePost("/googleApi/getLocationSuggestions");
  const {
    post: getLocationPlaceDetails,
    data: placDetails,
    isLoading: getLocationPlaceDetailsLoading,
  } = usePost("/googleApi/getLocationPlaceDetails");

  const [placePredictions, setPlacePredictions] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [updateSessionId, setUpdateSessionId] = useState("");

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue("");
    }
  }, [value]);

  useEffect(() => {
    if (suggestionsdata?.result?.suggestions?.length > 0) {
      setUpdateSessionId(suggestionsdata?.result?.session_id);
      // let newSuggestion = {
      //   text: "Remote",
      //   placeID: "",
      //   docID: "",
      // };
      // setPlacePredictions([
      //   newSuggestion,
      //   ...suggestionsdata?.result?.suggestions,
      // ]);
      setPlacePredictions(suggestionsdata?.result?.suggestions)
    } else {
      setPlacePredictions([]);
    }
  }, [suggestionsdata]);

  useEffect(() => {
    if (placDetails?.status) {
      const getComponent = (types) =>
        placDetails?.result?.details?.entity_type?.find((c) =>
          types.some((t) => c?.types?.includes(t))
        )?.longText || "";

      const city =
        placDetails?.result?.details?.entity_details?.[0]?.city ||
        getComponent(["locality", "postal_town", "city"]);
      const state =
        placDetails?.result?.details?.entity_details?.[0]?.state ||
        getComponent(["administrative_area_level_1"]);
      const country =
        placDetails?.result?.details?.entity_details?.[0]?.country ||
        getComponent(["country"]);
      const pincode =
        placDetails?.result?.details?.entity_details?.[0]?.pincode ||
        getComponent(["postal_code"]);
      const lat =
        placDetails?.result?.details?.entity_details?.[0]?.pin?.lat || 0;
      const lng =
        placDetails?.result?.details?.entity_details?.[0]?.pin?.lon || 0;
      const fullAddress = value;
      locationObj.current.city = city;
      locationObj.current.state = state;
      locationObj.current.country = country;
      locationObj.current.zipcode = pincode;
      if (city && city !== "") {
        locationObj.current.pin.lat = lat;
        locationObj.current.pin.lon = lng;
      } else {
        locationObj.current.pin = {};
      }
      locationObj.current.text = fullAddress ? fullAddress : "";
      setPlacePredictions([]);
      setShowSuggestions(false);
      setActiveIndex(-1);
    }
  }, [placDetails]);

  const fetchPlacePredictions = async (text, triggerKey) => {
    try {
      let request = {
        prefix: text,
        session_id: "",
        region:
          loaderDetails?.companyLocations?.length > 0
            ? loaderDetails?.companyLocations
            : ["US"],
        source: "MRJSV4",
        auth_key: loaderDetails?.companydetails?.authKey,
        isStreetRequired: false,
        companyID: loaderDetails?.companyID ? loaderDetails?.companyID : ""
      };
      getLocationSuggestions(request);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching place predictions:", error);
    }
  };
  const handleKeyDown = async (e) => {
    if (e?.key === "Enter" && activeIndex === -1) {
      setShowSuggestions(false);
    }
    if (e?.key === "Enter" && page == "Search" && activeIndex === -1) {
      setShowSuggestions(false);
      setValue("");
    }
    if (e.key === "Enter" && value.trim() && activeIndex !== -1) {
      e.preventDefault();
      const selectedText = placePredictions[activeIndex]?.text;
      setValue(selectedText);
      handlePredictionClick(placePredictions[activeIndex], activeIndex);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < placePredictions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : placePredictions.length - 1
      );
    }
  };

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setValue(value);
    if (value !== "") {
      fetchPlacePredictions(value);
    } else {
      setPlacePredictions([]);
      setShowSuggestions(false);
    }
  };

  const handlePredictionClick = (item, index) => {
    const selectedText = item?.text;
    setValue(selectedText);
    // if (selectedText == "Remote") {
    //   locationObj.current.city = "";
    //   locationObj.current.state = "";
    //   locationObj.current.country = "";
    //   locationObj.current.zipcode = "";
    //   locationObj.current.pin = {};
    //   locationObj.current.text = selectedText;
    //   setPlacePredictions([]);
    //   setShowSuggestions(false);
    //   setActiveIndex(-1);
    // } else {
      const updatedObj = {
        ...item,
        session_id: updateSessionId,
        auth_key: loaderDetails?.companydetails?.authKey,
        source: "MRJSV4",
        isStreetRequired: false,
        companyID: loaderDetails?.companyID ? loaderDetails?.companyID : ""
      };
      getLocationPlaceDetails(updatedObj);
    // }
  };

  const handleEnterSomeText = (event) => {
    if (event?.target?.value == "") {
      locationObj.current.city = "";
      locationObj.current.state = "";
      locationObj.current.country = "";
      locationObj.current.zipcode = "";
      locationObj.current.pin = {};
      locationObj.current.text = "";
    }
  };

  return (
    <div className="position-relative">
      <Form.Control
        type="text"
        id="loc-input-92x"
        name="loc_92x"
        autoComplete="one-time-code"
        placeholder={placeholder || "Enter your location"}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 300)}
        className="custom-placeholder no-border"
        size={size || "md"}
        onInput={handleEnterSomeText}
      />
      {showSuggestions && placePredictions?.length > 0 && (
        <Card.Body
          className={`position-absolute p-0 m-0 z-3 bg-white shadow mt-1 cardBodyLocationCss ${autoSuggestCssClassName
              ? autoSuggestCssClassName
              : "custom-suggestion-box"
            }`}
        >
          {placePredictions.map((item, index) => (
            <div
              className={`row border p-0 m-0 pb-2 pt-2 w-100 ${activeIndex === index ? "bg-light" : ""
                }`}
              role="button"
              key={item?.text}
              onClick={() => handlePredictionClick(item, index)}
            >
              <div className="col-12">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-primary me-1"
                />
                <span>{item?.text}</span>
              </div>
            </div>
          ))}
        </Card.Body>
      )}
    </div>
  );
};

export default NewLocationInput;
